/* Inline Arabic logo SVG to ensure it renders in WebView/print without external asset resolution */
export default function LogoArSvg(props: React.SVGProps<SVGSVGElement>) {
  const { style, ...rest } = props || {};
  return (
    // eslint-disable-next-line react/no-unknown-property
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 2961.000000 1509.000000'
      preserveAspectRatio='xMidYMid meet'
      style={{ display: "block", ...(style || {}) }}
      {...rest}
    >
      <g
        transform='translate(0.000000,1509.000000) scale(0.100000,-0.100000)'
        fill='#000000'
        stroke='none'
      >
        <path
          d='M23385 15064 c-584 -21 -988 -81 -1309 -194 -48 -17 -126 -42 -174
-56 -97 -28 -201 -80 -259 -128 -21 -17 -76 -59 -122 -91 -249 -177 -400 -403
-442 -659 -17 -106 -7 -299 21 -401 69 -254 229 -459 443 -564 135 -66 209
-85 312 -77 44 3 123 8 175 12 63 4 110 13 140 26 25 11 63 27 84 34 76 27
170 113 317 290 562 676 1254 1016 2186 1075 204 13 309 6 562 -37 580 -99
1113 -362 1523 -752 49 -47 98 -98 109 -113 19 -27 15 -26 -58 18 -96 57 -287
148 -410 197 -324 126 -702 196 -1068 196 -504 0 -912 -85 -1274 -266 -205
-102 -288 -160 -422 -294 -279 -277 -353 -518 -254 -817 56 -168 190 -333 317
-393 176 -82 363 -77 553 15 115 55 195 127 287 259 98 139 274 312 412 405
541 361 1214 449 1840 241 646 -216 1188 -752 1572 -1555 371 -776 554 -1665
554 -2680 0 -1078 -191 -2023 -579 -2875 -183 -400 -463 -867 -710 -1185 -443
-569 -886 -997 -1366 -1317 -66 -44 -122 -82 -123 -83 -2 -2 16 2 40 9 231 70
683 356 1068 676 168 140 578 551 727 730 375 451 675 916 893 1387 287 622
482 1323 570 2043 43 359 53 525 53 880 0 357 -13 570 -54 920 -93 790 -385
1639 -811 2358 -578 974 -1370 1710 -2361 2192 -630 307 -1228 477 -1952 556
-143 15 -766 26 -1010 18z m-1615 -518 c0 -2 -16 -29 -35 -61 -250 -416 -182
-1022 155 -1364 62 -63 62 -63 28 -56 -64 13 -167 53 -230 88 -282 159 -444
478 -398 782 38 248 188 462 413 586 49 27 67 34 67 25z m2204 -1393 c-65
-130 -86 -221 -86 -378 0 -153 20 -245 81 -370 41 -85 115 -191 159 -226 l27
-21 -35 7 c-151 32 -294 135 -375 270 -53 89 -77 174 -78 280 -1 156 51 282
163 396 54 55 158 129 181 129 4 0 -13 -39 -37 -87z'
        />
        <path
          d='M12455 13669 c-614 -33 -1297 -137 -2040 -310 -1104 -258 -1862 -529
-2860 -1024 -658 -326 -1050 -550 -2475 -1412 -1060 -641 -1631 -897 -2485
-1117 -182 -46 -361 -94 -400 -106 -355 -109 -594 -192 -1340 -465 -176 -65
-405 -147 -510 -182 -210 -71 -248 -90 -271 -136 -22 -41 -15 -138 12 -168 76
-85 795 -349 1044 -384 39 -5 109 13 551 149 604 185 946 291 1534 476 1184
372 1736 521 2350 634 975 179 2232 240 3325 161 657 -48 1333 -146 1960 -285
209 -47 291 -67 830 -204 895 -227 1585 -369 2300 -471 1245 -177 2499 -198
3820 -64 826 84 1428 188 2655 459 978 216 1291 278 1791 355 292 45 383 74
405 132 19 52 -12 92 -178 224 -300 240 -550 367 -798 405 -132 21 -174 16
-598 -62 -1380 -253 -2453 -392 -3552 -460 -354 -21 -1280 -30 -1640 -15
-1085 45 -2049 146 -2920 306 -293 54 -469 91 -1122 239 -1472 333 -2025 423
-2812 458 -312 14 -620 4 -1381 -42 -306 -19 -627 -33 -840 -36 l-345 -4 50
18 c72 28 165 75 289 150 60 35 264 141 455 235 1230 603 1883 854 2876 1105
761 193 1428 306 2145 362 224 18 851 24 1090 11 1622 -90 3218 -579 4945
-1516 244 -132 374 -196 505 -248 383 -150 706 -187 1159 -132 299 36 460 45
786 45 417 0 705 -20 1235 -86 542 -67 1025 -144 1335 -213 732 -163 1345
-436 1800 -802 125 -101 190 -143 286 -188 171 -80 365 -109 607 -91 178 14
388 38 432 51 72 20 110 70 110 144 0 66 -29 111 -185 293 -66 76 -192 226
-280 333 -349 424 -588 623 -973 810 -1130 549 -2313 819 -3582 819 -310 0
-558 -13 -920 -46 -629 -58 -901 -48 -1184 47 -99 33 -141 53 -1271 611 -799
395 -1015 496 -1317 617 -983 392 -1822 568 -2958 621 -249 11 -1224 11 -1445
-1z'
        />
        <path
          d='M3660 8450 c-497 -31 -979 -151 -1413 -352 -451 -208 -919 -533
-1190 -826 -469 -505 -726 -1007 -814 -1589 -26 -172 -23 -596 5 -778 57 -367
142 -625 311 -950 278 -535 667 -943 1118 -1173 181 -92 635 -227 963 -286
260 -47 316 -51 665 -51 509 1 741 37 1245 196 233 73 603 249 930 442 l145
85 35 -15 c97 -43 359 -125 470 -148 375 -78 901 -21 1199 130 l64 32 86 -37
c122 -53 287 -105 421 -132 102 -20 142 -23 360 -22 203 0 266 4 370 22 171
29 287 64 405 121 168 82 286 187 363 322 113 201 242 665 342 1234 117 665
256 1037 450 1205 33 29 57 57 54 62 -29 47 -433 158 -689 189 -91 11 -112 10
-234 -10 -158 -26 -261 -63 -363 -130 -144 -94 -234 -215 -298 -396 -57 -164
-78 -283 -110 -625 -73 -778 -111 -1001 -204 -1195 -85 -177 -200 -265 -361
-273 -87 -5 -196 10 -252 33 l-33 14 25 63 c85 222 135 400 185 668 103 550
198 969 260 1145 67 187 160 347 266 453 l63 62 -23 15 c-92 61 -497 162 -721
182 -84 7 -312 -34 -408 -73 -89 -35 -195 -106 -253 -166 -63 -66 -138 -172
-164 -234 -66 -153 -119 -491 -160 -1014 -29 -364 -53 -523 -106 -700 -68
-223 -165 -360 -300 -422 -42 -20 -66 -23 -164 -23 -119 0 -188 13 -227 43
l-22 17 75 230 c61 188 82 274 120 475 134 718 230 1118 310 1286 47 99 138
234 215 318 l63 68 -24 18 c-66 50 -507 159 -715 177 -75 6 -234 -19 -370 -58
-169 -49 -353 -207 -439 -377 -85 -168 -147 -569 -206 -1332 -18 -235 -53
-326 -169 -438 -329 -317 -703 -500 -1145 -558 -163 -22 -458 -14 -600 15
-272 56 -446 122 -645 246 -135 83 -234 161 -334 262 -211 213 -333 439 -399
743 -20 94 -22 132 -22 360 0 283 4 314 84 611 136 501 344 923 613 1244 47
55 144 158 217 228 472 455 990 739 1555 852 217 44 289 50 570 50 290 0 377
-9 594 -62 226 -54 513 -176 688 -290 20 -13 23 -13 23 -1 0 14 -129 125 -246
213 -169 127 -543 326 -769 409 -435 160 -875 225 -1335 196z'
        />
        <path
          d='M17270 8303 c-169 -10 -515 -64 -534 -83 -6 -6 9 -25 40 -52 303
-260 479 -688 533 -1298 28 -309 25 -744 -4 -720 -15 12 -15 12 -35 -215 -14
-150 -96 -812 -150 -1210 -37 -267 -42 -332 -49 -590 -8 -316 -11 -329 -72
-406 -70 -88 -122 -97 -679 -110 -245 -5 -877 -8 -1405 -7 -839 3 -967 6
-1013 19 -29 9 -55 19 -58 22 -4 3 30 59 74 124 261 386 417 907 382 1273 -22
217 -103 480 -191 615 -213 328 -497 524 -849 586 -100 18 -441 18 -540 1
-190 -34 -471 -119 -606 -183 -147 -69 -317 -189 -549 -385 -146 -123 -207
-188 -327 -348 -213 -284 -361 -573 -428 -836 -56 -218 -73 -462 -46 -648 51
-345 159 -574 371 -787 200 -200 387 -288 751 -355 137 -25 236 -25 387 0 65
12 123 20 128 18 15 -5 -124 -188 -206 -272 -138 -140 -277 -225 -439 -266
-99 -25 -282 -27 -392 -5 -159 33 -341 111 -505 216 -42 27 -79 49 -82 49 -13
0 -99 -185 -132 -284 -51 -151 -65 -259 -65 -497 0 -231 11 -314 62 -457 96
-275 217 -413 462 -527 121 -56 196 -79 346 -107 160 -29 272 -29 430 1 175
32 279 65 393 122 245 122 453 312 623 567 87 131 136 231 202 413 163 446
243 830 268 1286 4 68 8 123 9 123 1 0 22 -9 46 -19 62 -28 183 -58 307 -77
96 -15 260 -16 1597 -15 952 1 1530 6 1600 12 188 18 379 66 453 115 21 14 30
12 115 -22 51 -20 135 -48 187 -62 l95 -27 935 -3 c812 -3 952 -1 1065 13 237
29 434 87 603 175 l93 49 44 -44 c78 -78 226 -137 430 -172 98 -16 172 -18
685 -18 558 0 579 1 704 23 212 39 403 103 535 181 l53 32 52 -49 c88 -83 223
-135 434 -167 59 -9 116 -21 128 -26 14 -7 182 -9 500 -6 389 3 499 7 584 21
282 46 488 122 668 245 152 104 302 279 368 427 94 212 207 622 339 1229 66
302 159 548 277 725 53 81 176 211 234 247 24 16 44 31 44 35 0 16 -346 106
-529 137 -177 30 -393 44 -561 37 -365 -15 -601 -104 -786 -298 -65 -68 -143
-180 -175 -253 -41 -93 -89 -396 -139 -870 -59 -576 -70 -635 -140 -781 -49
-102 -111 -171 -192 -215 -61 -33 -67 -34 -193 -37 -152 -4 -229 7 -305 46
-56 28 -115 93 -126 139 -4 16 5 55 29 116 22 56 64 215 107 407 99 436 215
895 246 970 45 111 130 273 184 349 60 84 159 187 219 227 23 14 41 30 41 34
0 10 -265 84 -410 114 -224 47 -359 59 -634 53 -309 -6 -416 -27 -596 -117
-217 -109 -397 -325 -443 -535 -36 -163 -85 -534 -127 -970 -11 -115 -27 -250
-36 -300 -18 -106 -65 -252 -101 -315 -44 -76 -127 -155 -196 -186 l-62 -29
-220 0 c-189 0 -228 3 -278 19 -69 23 -145 87 -171 144 l-18 39 35 84 c23 54
56 174 92 334 95 422 234 971 265 1050 102 257 240 458 393 571 31 23 53 45
49 48 -23 14 -295 88 -404 110 -234 47 -281 51 -578 51 -311 0 -370 -7 -537
-64 -226 -78 -421 -253 -523 -472 -49 -108 -99 -427 -160 -1039 -33 -325 -47
-411 -86 -530 -56 -167 -151 -280 -276 -327 -37 -13 -93 -15 -388 -14 -335 2
-448 9 -533 32 -57 15 -128 89 -155 162 l-21 56 74 333 c261 1175 434 1823
659 2465 121 347 130 388 123 562 -10 271 -87 435 -296 634 -234 222 -541 356
-931 407 -85 11 -367 19 -470 13z m-4407 -3636 c69 -38 127 -104 153 -177 22
-60 30 -239 15 -326 -29 -167 -111 -353 -220 -497 -236 -315 -467 -469 -702
-469 -111 0 -175 28 -248 108 -70 77 -94 151 -93 299 0 128 28 249 92 403 72
171 276 426 440 549 201 150 414 192 563 110z'
        />
        <path
          d='M20240 7553 c-65 -11 -109 -27 -191 -70 -203 -105 -351 -238 -423
-383 -50 -100 -61 -151 -60 -281 l1 -117 43 -88 c76 -152 184 -247 340 -300
85 -29 327 -27 433 4 156 45 283 117 413 236 l70 64 49 -66 c56 -73 117 -119
203 -153 70 -28 269 -38 364 -19 117 23 299 123 404 222 100 95 153 196 174
336 34 216 -106 434 -323 504 -87 29 -261 28 -372 -1 -106 -28 -224 -87 -309
-155 -38 -31 -72 -56 -75 -56 -3 0 -19 26 -36 58 -42 81 -146 182 -228 221
-127 61 -296 76 -477 44z'
        />
        <path
          d='M25785 7489 c-106 -11 -160 -26 -250 -69 -240 -115 -397 -275 -458
-465 -18 -56 -22 -92 -21 -180 1 -100 4 -116 31 -175 72 -157 188 -261 338
-306 94 -29 314 -26 422 5 144 41 316 151 435 280 179 193 210 465 78 670
-121 187 -316 269 -575 240z'
        />
        <path
          d='M21957 2764 c-198 -36 -487 -238 -590 -414 -62 -106 -82 -186 -81
-318 l1 -112 46 -94 c106 -213 256 -310 497 -323 127 -6 255 13 368 57 95 37
236 127 324 209 l67 62 29 -43 c39 -57 120 -131 170 -157 70 -35 150 -51 262
-51 131 0 207 18 322 75 250 124 378 277 409 490 21 142 -22 271 -130 387
-200 216 -611 189 -905 -59 -22 -18 -42 -33 -45 -33 -3 0 -19 26 -36 58 -37
73 -144 181 -214 216 -125 64 -314 83 -494 50z'
        />
        <path
          d='M1992 1799 c-349 -45 -629 -346 -649 -699 -14 -248 109 -425 340
-487 82 -22 276 -22 370 1 223 53 324 176 295 357 l-10 66 -56 -61 c-77 -85
-88 -93 -165 -117 -55 -17 -86 -20 -155 -17 -143 7 -238 62 -291 170 -59 117
-37 284 54 407 81 110 194 179 309 188 l61 5 22 -38 c37 -67 66 -87 131 -92
77 -6 139 13 179 53 28 28 33 40 33 79 0 60 -15 90 -60 120 -93 61 -248 86
-408 65z'
        />
        <path
          d='M3152 1794 c-24 -8 -77 -35 -118 -59 -289 -171 -488 -431 -566 -738
-26 -105 -23 -272 7 -332 l20 -40 144 -8 c91 -6 147 -5 153 1 6 6 0 46 -17
115 -16 66 -25 125 -23 159 l3 53 55 27 c74 37 239 69 387 75 l122 6 11 -29
c22 -57 -21 -163 -125 -309 -45 -62 -60 -92 -52 -97 7 -4 67 -8 135 -8 l122 0
40 41 c91 94 150 284 158 506 8 242 -38 376 -177 513 -116 115 -200 152 -279
124z m78 -261 c47 -53 100 -171 107 -237 l6 -56 -253 0 -252 0 7 28 c18 75
143 218 240 273 70 40 105 38 145 -8z'
        />
        <path
          d='M7315 1791 c-27 -10 -81 -37 -120 -61 -287 -176 -480 -430 -557 -733
-26 -105 -23 -272 7 -332 l20 -40 144 -8 c91 -6 147 -5 153 1 6 6 0 46 -17
115 -16 66 -25 125 -23 159 l3 53 55 27 c74 37 239 69 387 75 l122 6 11 -29
c22 -57 -21 -163 -125 -309 -45 -62 -60 -92 -52 -97 7 -4 67 -8 135 -8 l122 0
38 40 c92 94 152 285 160 507 5 169 -10 254 -65 366 -61 122 -219 261 -318
281 -18 3 -50 -2 -80 -13z m85 -258 c47 -53 100 -171 107 -237 l6 -56 -253 0
-252 0 7 28 c18 75 143 218 240 273 70 40 105 38 145 -8z'
        />
        <path
          d='M8330 1800 c-129 -16 -223 -54 -317 -129 -59 -46 -113 -142 -113
-200 0 -98 120 -181 365 -251 142 -40 163 -48 203 -78 68 -49 93 -131 53 -171
-79 -79 -309 -116 -449 -72 -104 32 -136 64 -157 154 l-11 49 -41 -41 c-55
-52 -74 -92 -80 -163 -10 -106 40 -184 157 -243 82 -42 171 -58 310 -57 197 1
345 50 453 150 64 61 94 108 113 183 47 183 -73 307 -387 398 -136 40 -171 54
-214 92 -67 59 -37 139 74 196 49 26 75 33 120 33 90 0 144 -24 222 -97 l68
-64 75 74 c88 86 93 106 39 140 -48 30 -155 73 -213 86 -69 15 -198 20 -270
11z'
        />
        <path
          d='M3884 1776 c-51 -37 -102 -227 -168 -626 -50 -297 -81 -518 -75 -524
2 -2 74 -5 159 -7 l155 -4 -2 25 c-2 14 -6 88 -9 166 l-7 140 32 36 c42 49
183 107 208 87 40 -34 137 -289 151 -399 l7 -55 163 -3 162 -2 0 63 c0 127
-39 226 -153 395 -43 62 -77 116 -77 120 0 4 48 38 105 76 162 106 217 180
218 295 1 99 -55 164 -173 203 -59 19 -94 21 -370 25 -263 4 -308 2 -326 -11z
m499 -172 c55 -19 97 -55 97 -85 0 -54 -156 -156 -359 -234 -119 -46 -131 -46
-131 3 0 57 36 189 65 239 25 41 60 67 115 84 44 13 165 10 213 -7z'
        />
        <path
          d='M5307 1772 c-22 -24 -52 -141 -78 -297 -37 -229 -16 -432 66 -626 37
-87 137 -247 161 -256 11 -4 68 46 199 177 125 125 188 181 198 177 12 -5 131
-172 248 -346 13 -21 18 -22 37 -12 28 15 156 168 222 266 107 159 205 370
250 540 24 92 60 308 60 360 l0 35 -102 0 -103 0 -1 -163 c-2 -193 -18 -265
-94 -425 -94 -196 -199 -330 -239 -305 -65 41 -65 418 -1 728 17 79 30 148 30
154 0 8 -42 11 -134 11 l-133 0 -6 -112 c-10 -215 -73 -431 -171 -598 -52 -88
-111 -160 -132 -160 -8 0 -25 21 -36 47 -75 170 -76 391 -2 683 19 74 34 136
34 138 0 1 -58 2 -128 2 -110 0 -131 -3 -145 -18z'
        />
        <path
          d='M9218 1783 c-44 -2 -81 -9 -86 -16 -16 -19 -97 -262 -157 -468 -55
-188 -76 -309 -94 -537 -5 -62 -7 -121 -4 -132 5 -19 14 -20 152 -20 80 0 152
4 160 9 12 8 13 16 3 49 -16 54 -15 198 3 312 14 86 18 98 49 127 49 45 120
64 268 70 l128 6 39 -39 c68 -68 64 -137 -16 -298 -19 -38 -53 -99 -77 -135
-73 -113 -86 -104 141 -96 109 4 201 9 204 11 11 6 37 168 65 408 23 200 26
256 21 435 -4 198 -15 272 -40 297 -15 14 -197 27 -216 15 -12 -8 -12 -38 -1
-205 7 -108 10 -199 6 -203 -4 -4 -80 -8 -169 -9 -102 -1 -192 -8 -242 -18
-117 -24 -119 -23 -110 21 4 21 36 120 71 221 36 101 62 187 59 193 -4 5 -23
8 -43 7 -20 -1 -71 -4 -114 -5z'
        />
      </g>
    </svg>
  );
}
